import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrdersListComponent } from './orders-list/orders-list.component'
import { OrderDetailsComponent } from './order-details/order-details.component'
import { ReimbursementListComponent } from './reimbursement-list/reimbursement-list.component'
import { ReimbursementDetailsComponent } from './reimbursement-details/reimbursement-details.component'
import { EscalationsComponent } from './escalations/escalations.component'
import { EscalationDetailsComponent } from './escalation-details/escalation-details.component'
import {PagenotfoundComponent} from './pagenotfound/pagenotfound.component'
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/auth.guard';
import { RefundPageComponent } from './refund-page/refund-page.component';
import { UcdUsersComponent } from './ucd-users/ucd-users.component';
import { AddUsersComponent } from './ucd-users/add-users/add-users.component';
import { LeadsComponent } from './leads/leads.component';
import { ChildOrdersListComponent } from './child-orders-list/child-orders-list.component';
const routes: Routes = [

  { path: 'orders', component: OrdersListComponent, canActivate:[AuthGuard]},
  { path: 'order-details/:orderId', component: OrderDetailsComponent,canActivate:[AuthGuard]},
  { path: 'reimbursements', component: ReimbursementListComponent, canActivate:[AuthGuard]},
  { path: 'reimbursement-details/:transId/:claimId', component: ReimbursementDetailsComponent,canActivate:[AuthGuard]},
  // { path: 'escalations', component: EscalationsComponent,
  //   children:[
  //     {
  //       path: 'pending', component: PendingComponent
  //     },
  //     {
  //       path: 'reallocate', component: ReallocateComponent
  //     },
  //     {
  //       path: '', redirectTo: 'pending' , pathMatch: 'full',
  //     }
  //   ]
  // },
  { path: 'escalations', component: EscalationsComponent, canActivate:[AuthGuard]},
  { path: 'escalation-details/:orderId/:statusId', component: EscalationDetailsComponent,canActivate:[AuthGuard]},
  { path: 'escalations/refund', component: RefundPageComponent, canActivate:[AuthGuard]},
  {
    path:'login', component:LoginComponent

  },
  { path:'users-dashboard', component:UcdUsersComponent },
  { path:'add-user', component:AddUsersComponent },
  { path:'leads', component:LeadsComponent },
  { path:'ordersList/:id', component:ChildOrdersListComponent },

 

  { path: '', redirectTo: '/login' , pathMatch: 'full'},
  
  //{ path: '', redirectTo: 'orders' , pathMatch: 'full'},
 
 //{path: '**', component: PagenotfoundComponent}
 //{path: '404', component: PagenotfoundComponent},
  //{path: '**', redirectTo: '/404'}
 
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
